import { RouteRecordRaw } from 'vue-router'

import useHasPermissionUser from '@/composables/useHasPermissionUser'

import IndexPage from '../pages/IndexPage.vue'

export default {
	path: '/groups',
	children: [
		{
			path: '',
			name: 'groups.index',
			component: IndexPage,
		},
		{
			path: ':id',
			name: 'groups.show',
			children: [
				{
					path: '',
					name: 'groups.show.id',
					component: () => import('@/modules/groups/pages/ShowPage.vue'),
				},
				{
					path: 'policies/create',
					name: 'groups.policies.create',
					component: () =>
						import('@/modules/groups/pages/CreatePolicyPage.vue'),
					beforeEnter: (to, from, next) => {
						const { hasPermissionUser } = useHasPermissionUser()

						if (
							hasPermissionUser('create-policies', 'App\\Models\\CompanyGroup')
						) {
							next()
						} else {
							next({
								path: '/error/not-found',
							})
						}
					},
				},
			],
		},
		{
			path: 'edit/:id',
			name: 'groups.edit',
			component: () => import('@/modules/groups/pages/EditPage.vue'),
			// Guard de router como sus rutas hermanas; antes solo bloqueaba el
			// HasPermission del componente.
			beforeEnter: (to, from, next) => {
				const { hasPermissionUser } = useHasPermissionUser()

				if (hasPermissionUser('update', 'App\\Models\\CompanyGroup')) {
					next()
				} else {
					next({
						path: '/error/not-found',
					})
				}
			},
		},
		{
			path: 'create',
			name: 'groups.create',
			component: () => import('@/modules/groups/pages/CreatePage.vue'),
			beforeEnter: (to, from, next) => {
				const { hasPermissionUser } = useHasPermissionUser()
				if (hasPermissionUser('create-groups', 'App\\Models\\Company')) {
					next()
				} else {
					next({
						path: '/error/not-found',
					})
				}
			},
		},
	],
} as RouteRecordRaw
